import {
    getNameDay,
    getTekDay,
    getTime,
    strToDate,
} from './../../application/global.function';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/application/config.service.';
import { RnumbService } from 'src/app/services/rnumb.service';
import { RecDoctorService } from './../../../services/to-doctor/rec-doctor.service';
import { IRnumbList } from 'src/app/interfaces/rnumb.interface';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

export interface ITalonTime {
    times: string;
    talon_id: number;
    type_r: string;
    spec?: string; // специальность
}

export interface ITalon {
    tekDay: string; // сегодня
    Weekday: string; // день недели
    time?: string; // Время (changed from ITalonTime[] to string)
    spec?: string; // специальность
}
@Component({
    selector: 'app-block-talons',
    templateUrl: './block-talons.component.html',
    styleUrls: ['./block-talons.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class BlockTalonsComponent implements OnInit {
    //  talons: Ihdoctor[] = [];
    talons: IRnumbList[] = [];
    talonsTime: ITalon[] = [];

    private _loadHistoryTalons = false;

    constructor(
        private rs: RnumbService,
        private configS: ConfigService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.talons = [];
        this.talonsTime = [];
        this.rs.getRnumbList().subscribe((results) => {
            //
            this.talons = results;
            this.talons.forEach((item) => {
                //
                /*
              item.beginDate = new Date(item.dat_bgn.replace(/(\d+).(\d+).(\d+) (\d+):(\d+)/, '$3/$2/$1 $4:$5'));
              item.endDate = new Date(item.dat_end.replace(/(\d+).(\d+).(\d+) (\d+):(\d+)/, '$3/$2/$1 $4:$5'));
  */
                item.beginDate = strToDate(item.dat_bgn);
                item.endDate = strToDate(item.dat_end);
            });

            this._loadHistoryTalons = false;

            //

            // Сортировка

            this.talons = this.talons.sort((a, b) => {
                if (!a.beginDate || !b.beginDate) {
                    return 0;
                }
                return a.beginDate.getTime() - b.beginDate.getTime();
            });
            this.convertFirstTwoTalonsToTalonsTime();

            //Группируем по дате
            // const source = from(this.talons);
            // @ts-ignore

            // const temp = source.pipe(
            //     groupBy((resspec) =>
            //         moment(resspec.beginDate).format('DD.MM.YYYY')
            //     ),
            //     mergeMap((group) => group.pipe(toArray()))
            // );

            // temp.subscribe((val) => {
            //     let tmpTime: ITalonTime[] = [];
            //     console.log('val', val);

            // val.splice(10); // Кол во талонов на день
            // val.forEach((item) => {
            //     tmpTime.push({
            //         time: this.getTime(item.beginDate!),
            //         talon_id: item.rnumb_id,
            //         type_r: item.type_r,
            // });
        });

        //     this.talonsTime.push({
        //         tekDay: this.getTekDay(val[0].beginDate!),
        //         Weekday: this.getNameDay(val[0].beginDate!),
        //         times: tmpTime,
        //     });
        // });
        // console.log(this.talonsTime);

        // // Только 3 записи
        // this.talonsTime.splice(2); // Кол дней
        // },
        // (error) => {
        //     this._loadHistoryTalons = false;
        //     console.error(error);
        // }
        // );
    }

    private convertFirstTwoTalonsToTalonsTime(): void {
        // Берем первые  две записи
        const firstTwoTalons = this.talons.slice(0, 2);

        this.talonsTime = firstTwoTalons.map((talon) => {
            if (!talon.beginDate) {
                return {
                    tekDay: '',
                    Weekday: '',
                    times: undefined,
                };
            }

            return {
                tekDay: this.getTekDay(talon.beginDate),
                Weekday: this.getNameDay(talon.beginDate),
                time: this.getTime(talon.beginDate),
                spec: talon.spec,
                rnumb_id: talon.rnumb_id,
                // times: [
                //     {
                //         talon_id: talon.rnumb_id,
                //         type_r: talon.type_r,
                //     },
                // ],
            };
        });
    }
    navigateToHistory(talon?: any) {
        if (talon && talon.rnumb_id) {
            // Navigate with query parameters
            this.router.navigate(['/home/history'], {
                queryParams: {
                    selectedAppointmentId: talon.rnumb_id,
                    tab: 0, // 0 for upcoming appointments
                },
            });
        } else {
            // Regular navigation
            this.router.navigate(['/home/history']);
        }
    }
    //TODO PIECE OF SHIT BELOW

    getTime(dt: Date): string {
        //    return moment(dt).utcOffset(0, false).format('HH:mm');
        return getTime(dt);
    }

    getTekDay(dt: Date): string {
        return getTekDay(dt);
    }

    getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    goTalon(talon: ITalon) {
        // Find the corresponding talon in the original talons array to get the type_r and talon_id
        const originalTalon = this.talons.find(
            (t) =>
                t.spec === talon.spec &&
                t.beginDate &&
                this.getTime(t.beginDate) === talon.time
        );

        if (originalTalon && originalTalon.type_r) {
            if (originalTalon.type_r == 'visit') {
                window.open(
                    `${this.configS.getValue(
                        'hostBackend'
                    )}/history/visit/pdf/${null}/${originalTalon.rnumb_id}.pdf`,
                    '_blank'
                );
            } else {
                this.router.navigate(['/home/history']);
            }
        } else {
            this.router.navigate(['/home/history']);
        }
    }
}
